import * as Yup from "yup";

export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const dateRegExp = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i;


const addFolderValidationSchema = Yup.object().shape({
    foldername: Yup.string()
        .required("Tên thư mục không được để trống"),
});

const addUrlLinkValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required("Tên không được để trống"),
    url: Yup.string()
        .required("Url không được để trống"),
});

const addContentValidationSchema = Yup.object().shape({
    content: Yup.string()
        .required("Nội dung không được để trống"),
});

export {
    addFolderValidationSchema,
    addContentValidationSchema,
    addUrlLinkValidationSchema
}